import useSWR from 'swr';
import { useSupabaseClient } from '@supabase/auth-helpers-react';

const listFields = 'id,updated_at,name,description,soil_analyses_data';

export default function useSoilAnalyses() {
  const supabase = useSupabaseClient();
  const { data, error, isLoading, mutate } = useSWR(
    'soil_analyses',
    async () => await supabase
      .from('soil_analyses')
      .select(listFields)
      .order('updated_at', { ascending: false })
      .throwOnError()
      .then(({ data }) => data),
    { fallbackData: [] }
  );

  // TODO: Write all functions as async
  // TODO: Refresh on session update

  const refresh = () => {mutate();};

  const insert = async (newSoilAnalyses) => {
    const { data } = await supabase
      .from('soil_analyses')
      .insert({ ...newSoilAnalyses })
      .select(listFields)
      .single()
      .throwOnError();

    mutate((rows) => [data, ...rows], { revalidate: false });
    return data;
  };

  const update = (newSoilAnalyses) => {
    mutate(
      async () => await supabase
        .from('soil_analyses')
        .update(newSoilAnalyses)
        .eq('id', newSoilAnalyses.id)
        .select(listFields)
        .single()
        .throwOnError(),
      {
        populateCache: ({ data }, rows) => [data, ...rows.filter(elem => elem.id !== data.id)],
        revalidate: false,
      }
    );
  };

  const deleteOne = (id) => {
    mutate(
      async () => await supabase
        .from('soil_analyses')
        .delete()
        .eq('id', id)
        .throwOnError(),
      {
        populateCache: (_, rows) => rows.filter(elem => elem.id !== id),
        revalidate: false,
      }
    );
  };

  const deleteAll = () => {
    mutate(
      async () => await supabase
        .from('soil_analyses')
        .delete()
        .neq('id', -1)
        .throwOnError(),
      {
        populateCache: () => [],
        revalidate: false,
      }
    );
  };

  return {
    data,
    error,
    isLoading,
    refresh,
    insert,
    update,
    deleteOne,
    deleteAll,
  };
}



